import React from 'react';
import {Translate} from 'react-redux-i18n';
import {useDispatch, useSelector} from 'react-redux';
import * as snackbarsActions from '../../actions/snackbars';
import {useCustomStore} from './GlobalSubcontractorsStore';
import GlobalSubcontractorsView from './GlobalSubcontractorsView';
import documentService from '../../services/document/DocumentService';
import {captureError} from '../../utils/log';

function GlobalSubcontractorsContainer() {
  const data = useSelector(state => ({
    userId: state.user.id,
    locale: state.i18n.locale
  }));
  const globalDispatch = useDispatch();
  const {dispatch} = useCustomStore();

  React.useEffect(() => {
    dispatch({type: 'FETCH_DATA'});
  }, []);

  function handleDownloadExport() {
    documentService.createDocumentExport(data)
      .then(() => globalDispatch(snackbarsActions.addSuccess(<Translate value="message.exportRequestSuccess"/>)))
      .catch(error => {
        captureError('Error while requesting export of global subcontractors dossier', error);
        globalDispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
      });
  }

  return (
    <GlobalSubcontractorsView
      onDownloadExport={handleDownloadExport}
    />
  );
}

export default GlobalSubcontractorsContainer;
